module.exports = __webpack_public_path__ + "img/pt.5697f29.svg";